import React, { useEffect, useRef } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { ToastContainer as ToastifyContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Theme } from '@app/theme';
import { useToast } from './useToast';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  toast: {
    '&.Toastify__toast-theme--colored.Toastify__toast--info': {
      backgroundColor: theme.colors.blueMuted,
      color: theme.colors.blueAccessible,
    },
    '&.Toastify__toast-theme--colored.Toastify__toast--success': {
      backgroundColor: theme.colors.greenMuted,
      color: theme.colors.greenAccessible,
    },
    '&.Toastify__toast-theme--colored.Toastify__toast--warning': {
      backgroundColor: theme.colors.yellowMuted,
      color: theme.colors.inkPrimary,
    },
    '&.Toastify__toast-theme--colored.Toastify__toast--error': {
      backgroundColor: theme.colors.redMuted,
      color: theme.colors.redAccessible,
    },
  },
  progress: {
    '&.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info': {
      backgroundColor: theme.colors.blue,
    },
    '&.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success': {
      backgroundColor: theme.colors.green,
    },
    '&.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning': {
      backgroundColor: theme.colors.inkPrimary,
    },
    '&.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error': {
      backgroundColor: theme.colors.red,
    },
  },
}));

interface Props {}

export const ToastContainer = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });
  const toast = useToast();
  const { t, i18n } = useTranslation();

  const dedup = useRef(false);
  useEffect(() => {
    const params = new URL(window.location.href).searchParams;

    if (params.get('error') && !dedup.current) {
      const tKey = `errors.${params.get('error')}`;
      if (i18n.exists(tKey)) {
        toast.error(t(tKey) as string);
        dedup.current = true;
      }
    }
  }, [toast, t, i18n]);

  return (
    <ToastifyContainer
      toastClassName={classes.toast}
      progressClassName={classes.progress}
      autoClose={2500}
      closeButton={false}
      theme="colored"
      icon={false}
    />
  );
};
